import { createMemoStyles } from '@wds/utils';
var useStyles = createMemoStyles(function (_ref) {
  var palette = _ref.palette,
    type = _ref.type;
  return {
    copyRight: {
      fontSize: type.fontSize.bodySm,
      color: palette.text.darkMuted
    }
  };
});
export default useStyles;
//# sourceMappingURL=useStyles.js.map